var maskBottom = "/static/30f59367eeff5444.png";

export { maskBottom as default };
//# sourceMappingURL=mask-bottom-new.png.js.map
